<template>
  <b-container class="mt-4">
      <b-alert :variant="validationVariant" :show="showValidationMessage"> {{validationMessage}} </b-alert>

    <b-form @submit.prevent="SignUp">
      <b-form-group
                    label="Email address:"
                    label-for="exampleInput1"
                    description="We'll never share your email with anyone else.">
        <b-form-input 
                      type="email"
                      v-model="email"
                      required
                      placeholder="Enter email">
        </b-form-input>
      </b-form-group>

      <b-form-group 
                    label="Company:"
                    label-for="exampleInput2">
        <b-form-input 
                      type="text"
                      v-model="companyName"
                      required
                      placeholder="Enter your company name">
        </b-form-input>
      </b-form-group>

      <b-form-group 
                    label="First Name:"
                    label-for="exampleInput2">
        <b-form-input 
                      type="text"
                      v-model="firstName"
                      required
                      placeholder="Enter your first name">
        </b-form-input>
      </b-form-group>

      <b-form-group 
                    label="Last Name:"
                    label-for="exampleInput2">
        <b-form-input 
                      type="text"
                      v-model="lastName"
                      required
                      placeholder="Enter your last name">
        </b-form-input>
      </b-form-group>

            <b-form-group 
                    label="Password:"
                    label-for="exampleInput2">
        <b-form-input 
                      type="password"
                      v-model="password"
                      required
                      placeholder="Enter a secure password">
        </b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary" :disabled="processing">Register</b-button>
    </b-form>
  </b-container>
</template>

<script>
import AuthService from "../../services/AuthService";
import NProgress from 'nprogress';

export default {
  name: "SignUp",
  data() {
    return {
      email: "",
      companyName: "",
      firstName: "",
      lastName: "",
      password: "",
      showValidationMessage : false,
      validationMessage : "",
      validationVariant: 'danger',
      processing: false
    };
  },
  methods: {
    SignUp() {
        NProgress.start();
        NProgress.set(0.1);
        var self = this;
        self.processing = true;
      AuthService.Register(
        self.email,
        self.password,
        self.firstName,
        self.lastName,
        self.companyName,
        (result) => {
          // self.$store.commit(
          //   "SetCredentials", { username: self.email, password: self.password, userInfo: result[0] }
          // );
          if(result == 'Account Created') {
            self.processing = false;
            NProgress.done();
          
            setTimeout(() => self.$router.push({ path: '/login' }), 1500);
          }
          else if(result == 'PENDING') {
            setTimeout(() => NProgress.done(), 500);
            self.processing = false;
            self.validationMessage = "Account Created. Please wait for an Administrator to approve your account.";
            self.validationVariant = 'success';
            self.showValidationMessage = true;

            self.email = "";
            self.companyName = "";
            self.firstName = "";
            self.lastName = "";
            self.password = "";
          }          
        },
        (error) => {
          setTimeout(() => NProgress.done(), 500);
          self.processing = false;
          if(error.Error == 'Contact not found') {
            self.validationMessage = 'Please contact the office on (02) 8850 7992 to sign up for the web shop.';
            self.showValidationMessage = true;
          }
          else if(error.Error == 'Login Exists') {
            self.validationMessage = 'A login with this username already exists. If you have forgotten your password please follow the prompts on the Login page to reset your password.';
            self.showValidationMessage = true;
          }
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auth/signup.vue